import React, { useContext } from "react";
import { getLabelTag, getLabelTagInput } from "../constructTextFromValues";
import {
  bowelIncontinenceOptions,
  ambulanceOptions,
  bladderIncontinenceOptions,
  ambulanceAssistanceOptions,
  ambulanceBedBoundOptions,
} from "../../Options/funcExamOptions";
import { Space } from "antd";
import SummaryWrapper from "../SummaryWrapper";
import { DoctorInitialContext } from "../../InspectionForms/HistoryForm/DoctorHistoryFormProvider";
import { FileTextOutlined } from "@ant-design/icons";

const DrFunctionalExaminationSummary = () => {
  const { formData } = useContext(DoctorInitialContext);
  const functionalExaminationSummaryItems = [];

  const constructFunctionalExaminationSummaryItems = () => {
    if (formData?.functional_examination?.ambulation) {
      functionalExaminationSummaryItems.push({
        key: "1",
        label: "Ambulation",
        children: (
          <>
            {getLabelTag(
              ambulanceOptions,
              formData?.functional_examination?.ambulation
            )}
            {getLabelTag(
              ambulanceAssistanceOptions,
              formData?.functional_examination?.ambulation_assistance
            )}
            {getLabelTagInput(
              "Others details",
              formData?.functional_examination?.ambulation_assistance_others
            )}
            {getLabelTag(
              ambulanceBedBoundOptions,
              formData?.functional_examination?.ambulation_bed_bound
            )}
          </>
        ),
      });
    }
    if (formData?.functional_examination?.bowel_incontinence) {
      functionalExaminationSummaryItems.push({
        key: "2",
        label: "Bowel Incontinence",
        children: getLabelTag(
          bowelIncontinenceOptions,
          formData?.functional_examination?.bowel_incontinence
        ),
      });
    }
    if (formData?.functional_examination?.bladder_incontinence) {
      functionalExaminationSummaryItems.push({
        key: "3",
        label: "Bladder Incontinence",
        children: getLabelTag(
          bladderIncontinenceOptions,
          formData?.functional_examination?.bladder_incontinence
        ),
      });
    }
    return functionalExaminationSummaryItems;
  };

  return (
    <SummaryWrapper
      items={constructFunctionalExaminationSummaryItems()}
      title={
        <Space>
          <span style={{ fontWeight: "normal" }}>
            <FileTextOutlined
              style={{ color: "var(--ant-primary-color)", fontWeight: "bold" }}
            />{" "}
            Functional Examination
          </span>
        </Space>
      }
    />
  );
};

export default DrFunctionalExaminationSummary;
